var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "file_image_svg__linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 236.18,
    y1: 151.82,
    x2: 322.68,
    y2: 151.82,
    gradientTransform: "matrix(0.0744186,0,0,0.0744186,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(27.45098%, 56.470588%, 100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17.254902%, 83.137255%, 94.901961%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "file_image_svg__linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 242.18,
    y1: 151.82,
    x2: 316.68,
    y2: 151.82,
    gradientTransform: "matrix(0.0744186,0,0,0.0744186,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(27.45098%, 56.470588%, 100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17.254902%, 83.137255%, 94.901961%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "file_image_svg__linear2",
    gradientUnits: "userSpaceOnUse",
    x1: 236.18,
    y1: 151.82,
    x2: 322.68,
    y2: 151.82,
    gradientTransform: "matrix(0.0744186,0,0,0.0744186,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(27.45098%, 56.470588%, 100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17.254902%, 83.137255%, 94.901961%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "file_image_svg__linear3",
    gradientUnits: "userSpaceOnUse",
    x1: 242.18,
    y1: 151.82,
    x2: 316.68,
    y2: 151.82,
    gradientTransform: "matrix(0.0744186,0,0,0.0744186,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(27.45098%, 56.470588%, 100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17.254902%, 83.137255%, 94.901961%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "file_image_svg__linear4",
    gradientUnits: "userSpaceOnUse",
    x1: 249.32,
    y1: 301.55,
    x2: 272.2,
    y2: 301.55,
    gradientTransform: "matrix(0.0744186,0,0,0.0744186,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(27.45098%, 56.470588%, 100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17.254902%, 83.137255%, 94.901961%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "file_image_svg__linear5",
    gradientUnits: "userSpaceOnUse",
    x1: 261.6,
    y1: 302.91,
    x2: 263,
    y2: 302.91,
    gradientTransform: "matrix(0.0744186,0,0,0.0744186,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(27.45098%, 56.470588%, 100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17.254902%, 83.137255%, 94.901961%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "file_image_svg__linear6",
    gradientUnits: "userSpaceOnUse",
    x1: 71.46,
    y1: 256.66,
    x2: 359.94,
    y2: 256.66,
    gradientTransform: "matrix(0.0744186,0,0,0.0744186,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(27.45098%, 56.470588%, 100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17.254902%, 83.137255%, 94.901961%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file_image_svg__surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#file_image_svg__linear0)"
    },
    d: "M 20.796875 14.515625 L 20.792969 14.515625 C 19.933594 14.515625 19.125 14.183594 18.519531 13.574219 C 17.910156 12.964844 17.574219 12.160156 17.578125 11.296875 C 17.578125 10.4375 17.910156 9.628906 18.519531 9.023438 C 19.125 8.414062 19.933594 8.082031 20.792969 8.082031 L 20.796875 8.082031 C 21.65625 8.082031 22.464844 8.414062 23.070312 9.023438 C 23.574219 9.523438 23.886719 10.160156 23.984375 10.851562 L 24.015625 10.851562 L 24.015625 11.296875 C 24.015625 11.296875 24.015625 11.296875 24.015625 11.300781 L 24.015625 11.746094 L 23.984375 11.746094 C 23.886719 12.4375 23.574219 13.074219 23.070312 13.574219 C 22.464844 14.183594 21.65625 14.515625 20.796875 14.515625 Z M 20.792969 13.625 C 21.417969 13.625 22 13.382812 22.4375 12.941406 C 22.769531 12.609375 22.992188 12.195312 23.078125 11.746094 L 23.011719 11.746094 C 22.925781 12.179688 22.710938 12.574219 22.394531 12.894531 C 21.964844 13.324219 21.398438 13.558594 20.792969 13.558594 C 20.191406 13.558594 19.625 13.324219 19.195312 12.898438 C 18.769531 12.46875 18.535156 11.902344 18.535156 11.296875 C 18.535156 10.695312 18.769531 10.128906 19.195312 9.699219 C 19.625 9.273438 20.191406 9.039062 20.792969 9.039062 C 21.398438 9.039062 21.964844 9.273438 22.390625 9.699219 C 22.710938 10.019531 22.925781 10.417969 23.011719 10.851562 L 23.078125 10.851562 C 22.992188 10.402344 22.769531 9.984375 22.4375 9.65625 C 22 9.214844 21.417969 8.972656 20.796875 8.972656 L 20.792969 8.972656 C 20.171875 8.972656 19.589844 9.214844 19.152344 9.652344 C 18.710938 10.09375 18.46875 10.675781 18.46875 11.296875 C 18.46875 11.921875 18.710938 12.503906 19.152344 12.941406 C 19.589844 13.382812 20.171875 13.625 20.792969 13.625 Z M 20.792969 9.929688 C 20.429688 9.929688 20.085938 10.074219 19.828125 10.332031 C 19.570312 10.589844 19.429688 10.933594 19.425781 11.296875 C 19.425781 11.664062 19.570312 12.007812 19.828125 12.265625 C 20.085938 12.523438 20.429688 12.664062 20.792969 12.664062 C 21.160156 12.664062 21.503906 12.523438 21.761719 12.265625 C 22.019531 12.007812 22.160156 11.664062 22.160156 11.296875 C 22.160156 10.933594 22.019531 10.589844 21.761719 10.332031 C 21.503906 10.074219 21.160156 9.929688 20.792969 9.929688 Z M 20.792969 9.929688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#file_image_svg__linear1)"
    },
    d: "M 23.085938 11.296875 L 22.609375 11.296875 C 22.609375 11.800781 22.40625 12.25 22.078125 12.582031 C 21.746094 12.910156 21.296875 13.109375 20.792969 13.113281 C 20.292969 13.113281 19.84375 12.910156 19.511719 12.582031 C 19.183594 12.25 18.980469 11.800781 18.980469 11.296875 C 18.980469 10.796875 19.183594 10.34375 19.511719 10.015625 C 19.84375 9.6875 20.292969 9.484375 20.792969 9.484375 C 21.296875 9.484375 21.746094 9.6875 22.078125 10.015625 C 22.40625 10.34375 22.609375 10.796875 22.609375 11.296875 L 23.566406 11.296875 C 23.566406 10.535156 23.253906 9.839844 22.753906 9.339844 C 22.253906 8.835938 21.558594 8.527344 20.792969 8.527344 C 20.03125 8.527344 19.335938 8.835938 18.835938 9.339844 C 18.332031 9.839844 18.023438 10.535156 18.023438 11.296875 C 18.023438 12.0625 18.332031 12.757812 18.835938 13.257812 C 19.335938 13.757812 20.03125 14.070312 20.792969 14.070312 C 21.558594 14.070312 22.253906 13.757812 22.753906 13.257812 C 23.253906 12.757812 23.566406 12.0625 23.566406 11.296875 L 23.085938 11.296875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%, 100%, 100%)",
      fillOpacity: 1
    },
    d: "M 17.835938 26.4375 L 18.402344 25.457031 L 25.5625 25.460938 L 26.132812 26.4375 Z M 17.835938 26.4375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%, 100%, 100%)",
      fillOpacity: 1
    },
    d: "M 25.355469 25.992188 L 18.609375 25.992188 L 18.660156 25.902344 L 25.304688 25.90625 L 25.355469 25.992188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#file_image_svg__linear2)"
    },
    d: "M 20.792969 14.515625 C 19.933594 14.515625 19.125 14.183594 18.519531 13.574219 C 17.910156 12.964844 17.578125 12.160156 17.578125 11.296875 C 17.578125 10.4375 17.910156 9.628906 18.519531 9.023438 C 19.125 8.414062 19.933594 8.082031 20.792969 8.082031 C 21.65625 8.082031 22.464844 8.414062 23.070312 9.023438 C 23.679688 9.628906 24.015625 10.4375 24.015625 11.300781 C 24.015625 12.160156 23.679688 12.96875 23.070312 13.574219 C 22.464844 14.183594 21.65625 14.515625 20.796875 14.515625 Z M 20.792969 9.929688 C 20.429688 9.929688 20.085938 10.074219 19.828125 10.332031 C 19.570312 10.589844 19.429688 10.933594 19.425781 11.296875 C 19.425781 11.664062 19.570312 12.007812 19.828125 12.265625 C 20.085938 12.523438 20.429688 12.664062 20.792969 12.664062 C 21.160156 12.664062 21.503906 12.523438 21.761719 12.265625 C 22.019531 12.007812 22.160156 11.664062 22.160156 11.296875 C 22.160156 10.933594 22.019531 10.589844 21.761719 10.332031 C 21.503906 10.074219 21.160156 9.929688 20.792969 9.929688 Z M 20.792969 9.929688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#file_image_svg__linear3)"
    },
    d: "M 20.796875 14.070312 L 20.792969 14.070312 C 20.03125 14.070312 19.335938 13.757812 18.835938 13.257812 C 18.332031 12.757812 18.023438 12.0625 18.023438 11.296875 C 18.023438 10.535156 18.332031 9.839844 18.835938 9.339844 C 19.335938 8.835938 20.03125 8.527344 20.792969 8.527344 L 20.796875 8.527344 C 21.558594 8.527344 22.253906 8.835938 22.753906 9.339844 C 23.253906 9.839844 23.566406 10.535156 23.566406 11.296875 C 23.566406 12.0625 23.253906 12.757812 22.753906 13.257812 C 22.253906 13.757812 21.558594 14.070312 20.796875 14.070312 M 20.792969 9.484375 C 20.292969 9.484375 19.84375 9.6875 19.511719 10.015625 C 19.183594 10.34375 18.980469 10.796875 18.980469 11.296875 C 18.980469 11.800781 19.183594 12.25 19.511719 12.582031 C 19.84375 12.910156 20.292969 13.109375 20.792969 13.113281 C 21.296875 13.113281 21.746094 12.910156 22.078125 12.582031 C 22.40625 12.25 22.609375 11.800781 22.609375 11.296875 C 22.609375 10.796875 22.40625 10.34375 22.078125 10.015625 C 21.746094 9.6875 21.296875 9.484375 20.792969 9.484375 M 23.566406 11.296875 L 23.566406 11.296875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#file_image_svg__linear4)"
    },
    d: "M 18.554688 23.28125 L 19.527344 21.601562 L 20.257812 22.859375 Z M 18.554688 23.28125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#file_image_svg__linear5)"
    },
    d: "M 19.46875 22.59375 L 19.527344 22.492188 L 19.570312 22.566406 L 19.46875 22.59375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#file_image_svg__linear6)"
    },
    d: "M 26.78125 26.019531 C 26.78125 26.003906 26.785156 25.992188 26.785156 25.976562 C 26.785156 25.960938 26.785156 25.945312 26.785156 25.929688 C 26.785156 25.917969 26.785156 25.90625 26.785156 25.894531 C 26.785156 25.875 26.785156 25.859375 26.785156 25.839844 C 26.785156 25.832031 26.78125 25.820312 26.78125 25.8125 C 26.78125 25.792969 26.777344 25.773438 26.773438 25.757812 C 26.773438 25.746094 26.769531 25.738281 26.769531 25.730469 C 26.765625 25.710938 26.761719 25.691406 26.757812 25.675781 C 26.753906 25.664062 26.75 25.65625 26.75 25.644531 C 26.742188 25.628906 26.738281 25.613281 26.734375 25.597656 C 26.726562 25.582031 26.722656 25.570312 26.71875 25.558594 C 26.710938 25.546875 26.707031 25.53125 26.699219 25.519531 C 26.6875 25.492188 26.675781 25.46875 26.660156 25.441406 L 22.765625 18.769531 C 22.597656 18.488281 22.292969 18.3125 21.964844 18.3125 L 21.960938 18.3125 C 21.632812 18.3125 21.328125 18.488281 21.164062 18.773438 L 20.078125 20.648438 L 14.945312 11.828125 C 14.78125 11.542969 14.472656 11.367188 14.144531 11.367188 C 13.816406 11.367188 13.511719 11.542969 13.34375 11.828125 L 5.445312 25.414062 C 5.429688 25.441406 5.414062 25.46875 5.402344 25.496094 C 5.398438 25.503906 5.394531 25.511719 5.394531 25.519531 C 5.382812 25.539062 5.375 25.5625 5.367188 25.582031 C 5.363281 25.589844 5.363281 25.597656 5.359375 25.605469 C 5.355469 25.628906 5.347656 25.648438 5.34375 25.671875 C 5.339844 25.675781 5.339844 25.683594 5.339844 25.691406 C 5.335938 25.714844 5.332031 25.738281 5.328125 25.761719 C 5.328125 25.765625 5.328125 25.773438 5.324219 25.777344 C 5.324219 25.800781 5.320312 25.824219 5.320312 25.851562 C 5.320312 25.855469 5.320312 25.859375 5.320312 25.867188 C 5.320312 25.890625 5.320312 25.914062 5.324219 25.9375 C 5.324219 25.945312 5.324219 25.949219 5.324219 25.953125 C 5.324219 25.980469 5.328125 26.003906 5.332031 26.027344 C 5.332031 26.03125 5.335938 26.039062 5.335938 26.042969 C 5.339844 26.0625 5.339844 26.078125 5.34375 26.097656 L 5.425781 26.4375 L 5.507812 26.4375 C 5.578125 26.535156 5.671875 26.617188 5.78125 26.683594 C 5.921875 26.765625 6.082031 26.808594 6.242188 26.808594 C 6.324219 26.808594 6.402344 26.796875 6.480469 26.777344 C 6.683594 26.722656 6.859375 26.605469 6.984375 26.4375 L 6.992188 26.4375 L 14.144531 14.136719 L 19.011719 22.492188 L 18.273438 23.769531 L 17.308594 25.441406 C 17.308594 25.441406 17.304688 25.445312 17.304688 25.449219 C 17.289062 25.46875 17.277344 25.492188 17.265625 25.515625 C 17.261719 25.53125 17.253906 25.542969 17.25 25.558594 C 17.246094 25.570312 17.238281 25.582031 17.234375 25.597656 C 17.230469 25.613281 17.222656 25.628906 17.21875 25.644531 C 17.214844 25.65625 17.214844 25.667969 17.210938 25.675781 C 17.207031 25.695312 17.203125 25.710938 17.199219 25.730469 C 17.195312 25.742188 17.195312 25.75 17.191406 25.757812 C 17.191406 25.777344 17.1875 25.796875 17.1875 25.8125 C 17.183594 25.824219 17.183594 25.835938 17.183594 25.84375 C 17.183594 25.859375 17.183594 25.878906 17.183594 25.894531 C 17.183594 25.910156 17.183594 25.921875 17.183594 25.933594 C 17.183594 25.949219 17.183594 25.964844 17.183594 25.980469 C 17.183594 25.996094 17.1875 26.011719 17.1875 26.027344 C 17.191406 26.039062 17.191406 26.050781 17.195312 26.0625 C 17.195312 26.066406 17.195312 26.070312 17.195312 26.074219 L 17.265625 26.4375 L 17.351562 26.4375 C 17.425781 26.546875 17.523438 26.636719 17.640625 26.707031 C 17.855469 26.832031 18.105469 26.863281 18.34375 26.800781 C 18.554688 26.742188 18.738281 26.617188 18.859375 26.4375 L 18.867188 26.4375 L 21.964844 21.082031 L 25.097656 26.4375 L 25.101562 26.4375 C 25.226562 26.621094 25.410156 26.75 25.625 26.804688 C 25.703125 26.828125 25.78125 26.835938 25.859375 26.835938 C 26.023438 26.835938 26.183594 26.792969 26.328125 26.710938 C 26.445312 26.640625 26.542969 26.546875 26.617188 26.4375 L 26.707031 26.4375 L 26.769531 26.070312 C 26.769531 26.070312 26.769531 26.066406 26.773438 26.0625 C 26.773438 26.050781 26.777344 26.035156 26.777344 26.023438 Z M 26.78125 26.019531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%, 96.862745%, 96.862745%)",
      fillOpacity: 1
    },
    d: "M 4.023438 26.917969 C 3.78125 26.917969 3.539062 26.816406 3.367188 26.644531 C 3.195312 26.472656 3.097656 26.234375 3.097656 25.992188 L 3.097656 6.007812 C 3.097656 5.765625 3.195312 5.527344 3.367188 5.355469 C 3.539062 5.183594 3.777344 5.082031 4.023438 5.082031 L 27.976562 5.082031 C 28.21875 5.082031 28.460938 5.183594 28.632812 5.355469 C 28.804688 5.527344 28.902344 5.765625 28.902344 6.007812 L 28.902344 25.992188 C 28.902344 26.234375 28.804688 26.472656 28.632812 26.644531 C 28.460938 26.816406 28.222656 26.917969 27.976562 26.917969 Z M 27.050781 25.066406 L 27.050781 6.933594 L 4.949219 6.933594 L 4.949219 25.066406 Z M 27.050781 25.066406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%, 96.862745%, 96.862745%)",
      fillOpacity: 1
    },
    d: "M 27.976562 25.992188 L 27.976562 25.511719 L 4.503906 25.511719 L 4.503906 6.488281 L 27.496094 6.488281 L 27.496094 25.992188 L 27.976562 25.992188 L 27.976562 25.511719 L 27.976562 25.992188 L 28.457031 25.992188 L 28.457031 6.007812 C 28.457031 5.882812 28.402344 5.761719 28.316406 5.671875 C 28.226562 5.582031 28.101562 5.53125 27.976562 5.53125 L 4.023438 5.53125 C 3.898438 5.53125 3.773438 5.582031 3.683594 5.671875 C 3.59375 5.761719 3.542969 5.882812 3.542969 6.007812 L 3.542969 25.992188 C 3.542969 26.117188 3.59375 26.242188 3.683594 26.328125 C 3.773438 26.417969 3.898438 26.46875 4.023438 26.46875 L 27.976562 26.46875 C 28.101562 26.46875 28.226562 26.417969 28.316406 26.328125 C 28.40625 26.238281 28.457031 26.117188 28.457031 25.992188 Z M 27.976562 25.992188 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileImage);
export default __webpack_public_path__ + "static/media/file_image.2cc9dca42e06ac393b5289920cc96c61.svg";
export { ForwardRef as ReactComponent };